import { useEffect, useState } from 'react';

/** Coarse clock for progress bars / “N min ago” without re-rendering the whole dashboard every frame. */
export function useSecondTick(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);
  return now;
}
